import { Col, Tooltip, Typography } from "antd";

const { Text } = Typography;

const Language = ({
  span,
  title,
  active,
  disabled,
  language,
  languageName,
  onLanguageClick,
}) => (
  <Col>
    <Tooltip title={title}>
      <Text
        strong={active}
        disabled={disabled}
        onClick={() => !disabled && onLanguageClick(language)}
        className={`pointer language-text${active ? " language-active" : ""}`}
      >
        {languageName}
      </Text>
    </Tooltip>
  </Col>
);

export default Language;
